/* eslint-disable */

// Request-specific action types for state management

// Table and Row Management
export const SET_SELECTED_ROW = 'LAB_DETAILS_CONTRACT/SET_SELECTED_ROW';
export const SET_API_DATA = 'LAB_DETAILS_CONTRACT/SET_API_DATA';

// Loading States
export const SET_LOADING = 'LAB_DETAILS_CONTRACT/SET_LOADING';


// Additional Table Actions
export const SET_CURRENT_ROW = 'LAB_DETAILS_CONTRACT/SET_CURRENT_ROW';
export const SET_RENDER_COUNT = 'LAB_DETAILS_CONTRACT/SET_RENDER_COUNT';
export const SET_TABLE_REF = 'LAB_DETAILS_CONTRACT/SET_TABLE_REF';

// Root Level State Management
export const SET_CURRENT_RENDER_COUNT = 'LAB_DETAILS_CONTRACT/SET_CURRENT_RENDER_COUNT';
export const SET_CONTRACT_API_URL = 'LAB_DETAILS_CONTRACT/SET_CONTRACT_API_URL';

// API Management
export const SET_API_LOADING = 'LAB_DETAILS_CONTRACT/SET_API_LOADING';
export const SET_API_ERROR = 'LAB_DETAILS_CONTRACT/SET_API_ERROR';
export const CLEAR_API_ERROR = 'LAB_DETAILS_CONTRACT/CLEAR_API_ERROR';